import { message } from 'ant-design-vue/es';
import { reactive } from 'vue';

import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { copy_role_info } from 'liyu-pc-base/api/permission/auth-manage';
import { event_obj } from 'liyu-pc-base/init-plugin';
import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';

export const btn_list: BtnListConfig = [
  {
    name: '修改',
    model_kind: 'custom_component',
    type: 'dropdown',
    clazz: 'primary',
    model_config: {
      title: '修改角色',
      component: 'roleConfig',
      init_data: {
        form_type: 'edit',
      },
    },
  },
  {
    name: '权限配置',
    type: 'dropdown',
    is_show: ({ record }) => {
      return record.is_active;
    },
    cb: ({ record }) => {
      const editModal = reactive({
        visible: true,
        role_id: record.id,
        aim_org_id: record.org_id,
        component: 'AuthEditModal',
        ok: (data: any) => {},
      });
      modalBox(editModal);
    },
  },
  {
    name: '复制角色',
    type: 'dropdown',
    is_show: ({ record }) => {
      return record.is_active;
    },
    cb: ({ record, current_org }) => {
      const editModal = reactive({
        open: true,
        title: '复制角色',
        form: {
          settings: {
            name: '表单名称',
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '角色名称',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 100,
              defaultValue: '',
              placeholder: '请填写角色名称',
            },
            {
              type: 'input',
              name: 'flag',
              label: '角色标识',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 100,
              defaultValue: '',
              placeholder: '请填写角色标识',
            },
            {
              type: 'textarea',
              name: 'desc',
              label: '角色描述',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              placeholder: '请填写角色描述',
            },
          ],
          rules: {
            name: [{ required: true, message: '角色名称必须填写' }],
          },
          model: reactive({
            org_id: current_org.id,
            name: '',
            desc: '',
            flag: '',
          }),
        },
        options: {},
        ok: data => {
          copy_role_info({
            ...data,
            org_id: current_org.id,
            role_id: record.id,
          }).then(() => {
            message.success('复制角色成功');
            event_obj().emit('refresh');
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '批量改名',
    model_kind: 'form',
    type: 'dropdown',
    clazz: 'primary',
    model_config: {
      ok_url: 'permission/batch_rename_role',
      api_fields: {
        role_id: 'id',
      },
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'vertical',
          col: [],
        },
        dynamicFieldList: [
          {
            key: '80485d8f9a9a47b5747344eebc3b38e3',
            children: [
              {
                type: 'input',
                label: '名称',
                disabled: false,
                allowClear: true,
                inputType: 'text',
                addonAfter: null,
                addonBefore: null,
                prefix: null,
                suffix: null,
                prefixIcon: null,
                suffixIcon: null,
                addonBeforeIcon: null,
                addonAfterIcon: null,
                placeholder: '请填写名称',
                maxlength: 100,
                name: 'name',
                key: '8d93a6f4d69e889d896ae4310e5ee7f0',
                span: 24,
                pull: 0,
                push: 0,
                offset: 0,
                queryType: 'advanced',
              },
              {
                type: 'select',
                label: '是否修改所有组织',
                disabled: false,
                allowClear: true,
                mode: 'default',
                placeholder: '请选择是否修改所有组织',
                show_search: false,
                valueKey: 'value',
                labelKey: 'name',
                name: 'all_org',
                key: '0fe11e5b2a4a9c5a7d8a109580788c1d',
                span: 24,
                pull: 0,
                push: 0,
                offset: 0,
                queryType: 'advanced',
              },
              {
                type: 'remoteselectpro',
                label: '目标组织',
                disabled: false,
                allowClear: true,
                valueKey: 'id',
                labelKeyType: 1,
                labelKey: 'name',
                labelKeyList: [],
                labelSpace: '-',
                mode: 'multiple',
                placeholder: '',
                show_search: true,
                datasourceType: 'remote',
                queryType: 'advanced',
                searchConditions: [
                  [
                    {
                      searchType: 3,
                      field_name: 'is_active',
                      operator: 'eq',
                      value: [true],
                      format: 'choices',
                      class_name: 'bool',
                    },
                  ],
                ],
                simpleSearchConditions: [
                  {
                    searchType: 3,
                    field_name: 'is_active',
                    value: true,
                  },
                ],
                postUrl: '/org/query_organization_list',
                name: 'org_ids',
                key: '7eae36ea0f07278138ce815838c6a10c',
                span: 24,
                pull: 0,
                push: 0,
                offset: 0,
                conditions: [
                  [
                    {
                      watchKey: 'all_org',
                      class_name: 'bool',
                      operator: 'eq',
                      value: [false],
                    },
                  ],
                ],
                table: {
                  enable: true,
                  columns: [
                    {
                      title: '名称',
                      dataIndex: 'name',
                      cellComponent: null,
                      sorter: {
                        multiple: 1,
                      },
                      autoHeight: false,
                      autoWidth: true,
                      width: 150,
                      resizable: true,
                      ellipsis: true,
                    },
                    {
                      title: '创建时间',
                      dataIndex: 'create_time',
                      cellComponent: 'datetime',
                      autoHeight: false,
                      autoWidth: false,
                      width: 150,
                      resizable: true,
                      ellipsis: true,
                    },
                    {
                      title: '更新时间',
                      dataIndex: 'update_time',
                      cellComponent: 'datetime',
                      autoHeight: false,
                      autoWidth: false,
                      width: 150,
                      resizable: true,
                      ellipsis: true,
                    },
                  ],
                  search_config: [
                    {
                      field_name: 'name',
                      label: '名称',
                      required_condition: null,
                      allowClear: true,
                      placeholder: '请输入名称',
                      format: 'input',
                      operator_list: [
                        'eq',
                        'contains',
                        'startswith',
                        'endswith',
                        'not_eq',
                        'is_or_not_blank_or_null',
                        'icontains',
                        'istartswith',
                        'iendswith',
                        'notcontains',
                        'notstartswith',
                        'notendswith',
                        'noticontains',
                        'notistartswith',
                        'notiendswith',
                      ],
                      default_operator: 'icontains',
                      class_name: 'str',
                      inputType: 'text',
                      autocomplete: 'off',
                      type: 'input',
                    },
                  ],
                },
              },
            ],
          },
        ],
        model: {
          name: null,
          all_org: true,
          org_ids: null,
        },
        rules: {},
        options: {
          all_org: [
            {
              value: true,
              valueType: 'bool',
              name: '是',
            },
            {
              value: false,
              valueType: 'bool',
              name: '否',
            },
          ],
          select_62516: [
            {
              valueType: 'int',
              value: 1,
              name: '选项1',
            },
            {
              valueType: 'int',
              value: 2,
              name: '选项2',
            },
            {
              valueType: 'int',
              value: 3,
              name: '选项3',
            },
          ],
        },
      },
    },
    order: 3,
    authority: 'permission/batch_rename_role',
  },
];

export const head_btn_list: HeadBtnListConfig = [
  {
    name: '新建角色',
    model_kind: 'custom_component',
    type: 'dropdown',
    clazz: 'primary',
    model_config: {
      title: '新建角色',
      component: 'roleConfig',
      init_data: {
        form_type: 'create',
      },
    },
  },
  {
    name: '导出权限',
    clazz: 'primary',
    model_kind: 'custom_component',
    model_config: {
      component: 'ExportRole',
    },
  },
  {
    name: '导入权限',
    clazz: 'primary',
    model_kind: 'custom_component',
    model_config: {
      component: 'ImportRole',
    },
  },
  {
    name: '同步角色',
    model_kind: 'custom_component',
    type: 'dropdown',
    clazz: 'primary',
    model_config: {
      title: '同步角色',
      component: 'SyncRole',
    },
    authority: 'permission/sync_role',
  },
];
